import { append } from 'ramda'
import {
  POST_OTP
} from '../actions/login-actions'

export default (state = [], action) => {
  switch (action.type) {
  case POST_OTP:
    return append(action.otp, state)
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/otps-posted.js